module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ledger-outstanding-upload-container"
  }, [_c('b-card', {
    staticClass: "upload-card"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Loading"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v(_vm._s(_vm.loadingMessage))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('b-alert', {
    staticClass: "mb-3",
    attrs: {
      "variant": "success",
      "dismissible": ""
    },
    on: {
      "dismissed": function($event) {
        _vm.successMessage = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle mr-2"
  }), _vm._v("\n      " + _vm._s(_vm.successMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('b-alert', {
    staticClass: "mb-3",
    attrs: {
      "variant": "danger",
      "dismissible": ""
    },
    on: {
      "dismissed": function($event) {
        _vm.errorMessage = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle mr-2"
  }), _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "file-upload-section"
  }, [_c('label', {
    staticClass: "upload-label"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o mr-2",
    staticStyle: {
      "color": "#28a745"
    }
  }), _vm._v("\n            Select Excel File\n          ")]), _vm._v(" "), _c('b-form-file', {
    staticClass: "mb-2",
    attrs: {
      "state": _vm.fileState,
      "accept": ".xlsx,.xls",
      "placeholder": "Choose a file or drop it here...",
      "drop-placeholder": "Drop file here...",
      "disabled": _vm.isLoading
    },
    on: {
      "input": _vm.handleFile
    },
    model: {
      value: (_vm.selectedFile),
      callback: function($$v) {
        _vm.selectedFile = $$v
      },
      expression: "selectedFile"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-1"
  }), _vm._v("\n            Accepted formats: .xlsx, .xls (Excel files only)\n          ")])], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "6"
    }
  }, [(_vm.selectedFile) ? _c('div', {
    staticClass: "file-info-section"
  }, [_c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "bg-variant": "light"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o mr-2",
    staticStyle: {
      "font-size": "24px",
      "color": "#28a745"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedFile.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.formatFileSize(_vm.selectedFile.size)))])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.clearFile
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1)])], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.jsonData.length > 0) ? _c('div', {
    staticClass: "preview-section mt-4"
  }, [_c('b-card', [_c('template', {
    slot: "header"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-table mr-2"
  }), _vm._v(" "), _c('strong', [_vm._v("Data Preview")]), _vm._v(" "), _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(_vm._s(_vm.searchedPreviewData.length) + " Records")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-input', {
    staticClass: "mr-2",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "placeholder": "Search Ledger Name...",
      "size": "sm"
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.togglePreview
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.showPreview ? 'fa-chevron-up' : 'fa-chevron-down'
  }), _vm._v("\n                " + _vm._s(_vm.showPreview ? "Hide" : "Show") + " Preview\n              ")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPreview),
      expression: "showPreview"
    }]
  }, [(_vm.searchedPreviewData.length > 0) ? _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "max-height": "400px",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-sm"
  }, [_c('thead', {
    staticClass: "thead-light",
    staticStyle: {
      "position": "sticky",
      "top": "0",
      "z-index": "10"
    }
  }, [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _vm._l((_vm.displayColumns), function(column) {
    return _c('th', {
      key: column,
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v("\n                    " + _vm._s(column) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedPreviewData), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.perPage + index + 1))]), _vm._v(" "), _vm._l((_vm.displayColumns), function(column) {
      return _c('td', {
        key: column
      }, [_vm._v("\n                    " + _vm._s(row[column] || "-") + "\n                  ")])
    })], 2)
  }))])]) : _c('div', {
    staticClass: "alert alert-warning mb-0"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle mr-2"
  }), _vm._v("\n            No valid data found. Please ensure your Excel file contains required columns.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-3 mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mr-2 mb-0"
  }, [_vm._v("Rows per page:")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pageOptions,
      "size": "sm"
    },
    on: {
      "change": function($event) {
        _vm.currentPage = 1
      }
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                Showing " + _vm._s((_vm.currentPage - 1) * _vm.perPage + 1) + " to\n                " + _vm._s(Math.min(_vm.currentPage * _vm.perPage, _vm.totalPreviewRows)) + " of\n                " + _vm._s(_vm.totalPreviewRows) + " records\n              ")])])]), _vm._v(" "), (_vm.totalPreviewRows > _vm.perPage) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "total-rows": _vm.totalPreviewRows,
      "per-page": _vm.perPage,
      "align": "center",
      "size": "sm"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-buttons mt-4"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary",
      "disabled": _vm.isLoading || (!_vm.selectedFile && _vm.jsonData.length === 0)
    },
    on: {
      "click": _vm.clearAll
    }
  }, [_c('i', {
    staticClass: "fa fa-times mr-1"
  }), _vm._v("\n            Clear All\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "px-4",
    attrs: {
      "variant": "primary",
      "disabled": _vm.jsonData.length === 0 || _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('i', {
    staticClass: "fa fa-upload mr-1"
  }), _vm._v("\n            " + _vm._s(_vm.isLoading ? "Uploading..." : "Submit Data") + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65546dbf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/LedgerOutstandingBulkUpload.vue
// module id = 2692
// module chunks = 0